:root ._dsp-flex{display:flex;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-row{flex-direction:row;}
:root ._width-10037{width:100%;}
:root ._items-center{align-items:center;}
:root ._items-stretch{align-items:stretch;}
:root ._pos-absolute{position:absolute;}
:root ._r-0px{right:0px;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._shrink-1{flex-shrink:1;}
:root ._justify-space-betwe3241{justify-content:space-between;}
:root ._grow-1{flex-grow:1;}
:root ._cur-pointer{cursor:pointer;}
:root ._ff-f-family{font-family:var(--f-family);}
:root ._dsp-inline{display:inline;}
:root ._ww-break-word{word-wrap:break-word;}
:root ._ws-pre-wrap{white-space:pre-wrap;}
:root ._mt-0px{margin-top:0px;}
:root ._mr-0px{margin-right:0px;}
:root ._mb-0px{margin-bottom:0px;}
:root ._ml-0px{margin-left:0px;}
:root ._col-color{color:var(--color);}
:root ._lh-24px{line-height:24px;}
:root ._fs-24px{font-size:24px;}
:root ._fd-column{flex-direction:column;}